import { validateAndStripCustomFunctions } from '../../shared/formula/validateAndStripCustomFunctions';
const Parser = require('expr-eval').Parser;


export function fetchFinancialGroupByAccount(account, accountStructure) {
    let financialGroup = [];

    if (account.financial_group_type === 1) {
        financialGroup = accountStructure.profitloss;
    } else if (account.financial_group_type === 2) {
        financialGroup = accountStructure.balancesheet.assets;
    } else if (account.financial_group_type === 3) {
        financialGroup = accountStructure.balancesheet.liabilities;
    } else if (account.financial_group_type === 4) {
        financialGroup = accountStructure.balancesheet.equities;
    } else if (account.financial_group_type === 5) {
        financialGroup = accountStructure.cashflow;
    } else if (account.financial_group_type === 6) {
        financialGroup = accountStructure.drivers;
    }
    return financialGroup;
}

export function fetchParentAccountGroupByAccount(account, accountStructure) {
    const financialGroup = fetchFinancialGroupByAccount(account, accountStructure);
    let parentAccount = [];

    function findParent(parentId, parent, financialGroup) {
        financialGroup.forEach((account) => {
            if (parentId === account.account_id || parentId === account.associated_account_id) {
                parent.push(account);
            } else if (account.children != null) {
                findParent(parentId, parent, account.children);
            }
        });
    }
    findParent(account.parent, parentAccount, financialGroup);

    return parentAccount[0].children;
}

export function fetchAccountById(accountId, fetchedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (const account of accounts) {
            if (
                account.associated_account_id == null &&
                (account.account_id === +accountId || account.account_id === accountId)
            ) {
                fetchedAccount['account'] = account;
                return;
            }
            if (account.children !== undefined) {
                fetchAccountById(accountId, fetchedAccount, account.children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts['associated_account_id'] == null && accounts[key].account_id === accountId) {
                fetchedAccount['account'] = accounts[key];
                return;
            }
            fetchAccountById(accountId, fetchedAccount, accounts[key]);
        }
    }
}

export function fetchAccountByAssociatedId(associatedAccountId, fetchedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (const account of accounts) {
            if (
                account.associated_account_id === +associatedAccountId ||
                account.associated_account_id === associatedAccountId
            ) {
                fetchedAccount['account'] = account;
                return;
            }
            if (account.children !== undefined) {
                fetchAccountByAssociatedId(associatedAccountId, fetchedAccount, account.children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].associated_account_id === associatedAccountId) {
                fetchedAccount['account'] = accounts[key];
                return;
            }
            fetchAccountByAssociatedId(associatedAccountId, fetchedAccount, accounts[key]);
        }
    }
}

export function fetchAccountByNumber(accountNumber, fetchedAccount, accounts) {
    if (Array.isArray(accounts)) {
        for (const account of accounts) {
            if (account.account_number === +accountNumber || account.account_number === accountNumber) {
                fetchedAccount['account'] = account;
                return;
            }
            if (account.children !== undefined) {
                fetchAccountByNumber(accountNumber, fetchedAccount, account.children);
            }
        }
    } else {
        for (const key in accounts) {
            if (accounts[key].account_number === accountNumber) {
                fetchedAccount['account'] = accounts[key];
                return;
            }
            fetchAccountByNumber(accountNumber, fetchedAccount, accounts[key]);
        }
    }
}

export function fetchAllAccountsByNumber(
    accountNumber,
    fetchedAccounts,
    accountStructure,
) {
    const targetNumber = String(
        accountNumber ?? '',
    ).trim();

    const visitRows = (rows) => {
        if (!Array.isArray(rows)) {
            return;
        }

        for (const row of rows) {
            if (!row || typeof row !== 'object') {
                continue;
            }

            // Separators are display-only.
            if (
                row.row_type === 'separator' ||
                row.separator_id != null
            ) {
                continue;
            }

            // Custom-tab rows can wrap the real account.
            const account = row.account ?? row;
            const currentNumber =
                account?.account_number;

            if (
                currentNumber != null &&
                String(currentNumber).trim() ===
                    targetNumber
            ) {
                fetchedAccounts.push(account);
            }

            if (Array.isArray(row.children)) {
                visitRows(row.children);
            }
        }
    };

    if (Array.isArray(accountStructure)) {
        visitRows(accountStructure);
        return fetchedAccounts;
    }

    if (
        !accountStructure ||
        typeof accountStructure !== 'object'
    ) {
        return fetchedAccounts;
    }

    visitRows(
        accountStructure.balancesheet?.assets,
    );

    visitRows(
        accountStructure.balancesheet?.liabilities,
    );

    visitRows(
        accountStructure.balancesheet?.equities,
    );

    visitRows(accountStructure.profitloss);
    visitRows(accountStructure.cashflow);
    visitRows(accountStructure.drivers);

    (accountStructure.custom || [])
        .flat()
        .forEach((tab) => {
            visitRows(
                tab?.custom_tab_accounts,
            );
        });

    return fetchedAccounts;
}

export function fetchAccountByKey(accountKey, accountStructure /*, accountPath = null*/) {
    const identifierElements = accountKey.split('.');
    let relatedAccount = null;

    //Check if the account key has valid syntax (BSA, BSL, BSE, PL, CF, or DRVE followed by . and a number)
    if (!checkValidKey(accountKey)) return undefined;

    if (identifierElements[0] === 'BSA') {
        relatedAccount = accountStructure.balancesheet.assets;
        //relatedAccountPath = Localization.common.balanceSheet + "/" + Localization.common.assets;
    } else if (identifierElements[0] === 'BSL') {
        relatedAccount = accountStructure.balancesheet.liabilities;
        //relatedAccountPath = Localization.common.balanceSheet + "/" + Localization.common.liabilities;
    } else if (identifierElements[0] === 'BSE') {
        relatedAccount = accountStructure.balancesheet.equities;
        //relatedAccountPath = Localization.common.balanceSheet + "/" + Localization.common.equities;
    } else if (identifierElements[0] === 'PL') {
        relatedAccount = accountStructure.profitloss;
        //relatedAccountPath = Localization.common.profitAndLoss;
    } else if (identifierElements[0] === 'CF') {
        relatedAccount = accountStructure.cashflow;
        //relatedAccountPath = Localization.common.cashFlow;
    } else if (identifierElements[0] === 'DRVE') {
        relatedAccount = accountStructure.drivers;
        //relatedAccountPath = Localization.common.drivers;
    } else {
        //Can leave this for now but we should never reach the else statement
        throw new Error(`Provided key not supported: ${accountKey}`);
    }

    for (let identifierIterator = 1; identifierIterator < identifierElements.length; identifierIterator++) {
        //when accounts are deleted, the IDs may no longer match the array indicies, so it is necessary
        //to loop through all subaccounts to guarantee that the account with the correct key is found.

        let found = false;

        if (relatedAccount.length) {
            for (let subIndex = 0; subIndex < relatedAccount.length; subIndex++) {
                const lowerAccount = relatedAccount[subIndex];
                const identifiers = lowerAccount.key.split('.');
                if (identifiers[identifiers.length - 1] === identifierElements[identifierIterator]) {
                    relatedAccount = lowerAccount;
                    found = true;
                    break;
                }
            }
            //relatedAccountPath = relatedAccountPath + "/" + relatedAccount.name;
        } else if (relatedAccount.children && relatedAccount.children.length) {
            for (let subIndex = 0; subIndex < relatedAccount.children.length; subIndex++) {
                const lowerAccount = relatedAccount.children[subIndex];
                const identifiers = lowerAccount.key.split('.');

                if (identifiers[identifiers.length - 1] === identifierElements[identifierIterator]) {
                    relatedAccount = lowerAccount;
                    found = true;
                    break;
                }
            }
            //relatedAccountPath = relatedAccountPath + "/" + relatedAccount.name;
        }

        //the account does not exist if the key element was not found in the current level of subaccounts
        if (!found) return null;
    }
    /*if (accountPath !== null && accountPath !== undefined) {
        accountPath = relatedAccountPath;
    }*/
    return relatedAccount;
}

export function recursiveRetrieveAllScenarios(entityParent, scenarios) {
    if (entityParent.length) {
        entityParent.forEach((entity) => {
            scenarios = recursiveRetrieveAllScenarios(entity, scenarios);
        });
    } else if (entityParent.children && entityParent.children.length) {
        entityParent.children.forEach((entity) => {
            scenarios = recursiveRetrieveAllScenarios(entity, scenarios);
        });
    } else {
        scenarios.push(entityParent);
    }
    return scenarios;
}

export function getScenarios(parentNode, scenarios) {
    if (parentNode.length) {
        parentNode.forEach((node) => {
            return getScenarios(node, scenarios);
        });
    } else if (parentNode.scenario && parentNode.scenario.length) {
        parentNode.scenario.forEach((entity) => {
            if (entity.scenario_id != null) {
                scenarios.push(entity);
            }
            return getScenarios(entity, scenarios);
        });
    }
    return scenarios;
}

export function getAccounts(accounts, accountStructure) {
    if (Array.isArray(accountStructure)) {
        accountStructure.forEach((account) => {
            if (
                account?.row_type === 'separator' ||
                account?.separator_id != null
            ) {
                return;
            }

            accounts.push(account);

            if (account.children != null) {
                getAccounts(
                    accounts,
                    account.children,
                );
            }
        });
    } else {
        for (const key in accountStructure) {
            getAccounts(
                accounts,
                accountStructure[key],
            );
        }
    }

    return accounts;
}

export function stripSeparatorsFromTree(rows) {
  return (rows || [])
    .filter(
      (row) =>
        row?.row_type !== 'separator' &&
        row?.separator_id == null,
    )
    .map((row) => ({
      ...row,
      children: Array.isArray(row.children)
        ? stripSeparatorsFromTree(row.children)
        : row.children,
    }));
}

export function buildCalculationAccountStructure(accountStructure) {
  if (!accountStructure) return accountStructure;

  return {
    ...accountStructure,
    balancesheet: {
      ...accountStructure.balancesheet,
      assets: stripSeparatorsFromTree(
        accountStructure.balancesheet?.assets,
      ),
      liabilities: stripSeparatorsFromTree(
        accountStructure.balancesheet?.liabilities,
      ),
      equities: stripSeparatorsFromTree(
        accountStructure.balancesheet?.equities,
      ),
    },
    profitloss: stripSeparatorsFromTree(
      accountStructure.profitloss,
    ),
    cashflow: stripSeparatorsFromTree(
      accountStructure.cashflow,
    ),
    drivers: stripSeparatorsFromTree(
      accountStructure.drivers,
    ),
    custom: (accountStructure.custom || []).map(
      (customTab) => ({
        ...customTab,
        custom_tab_accounts:
          stripSeparatorsFromTree(
            customTab.custom_tab_accounts,
          ),
      }),
    ),
  };
}

export function retrieveAccountNumbersFromFormula(formula) {
    const accountVariableRegex = /\{(.*?)\}/g;
    const matches = formula.match(accountVariableRegex);

    //For now, formulas with no account values are considered valid.
    if (matches === null) return [];

    return matches.map((key) => {
        return key.substring(1, key.length - 1);
    });
}

export function checkValidKey(key) {
    return /^(?:BSA|BSL|BSE|PL|CF|DRVE)\.(?:[0-9]|\.)+$/.test(key);
}

//Checks if a formula is valid, including checking if the referenced accounts actually exist
export function validateFormula(formula, accountStructure) {
    // Expand all supported formula functions first
    //Error codes: Umatched brace error = 1, invalid account key = 2, invalid mathematical expression = 3
// 1) braces first
    if (!checkBraces(formula)) return { status: 1, error: 'Oops! Missing "{" or "}".' };
 // 2) validate referenced accounts
    const accountNumbers = retrieveAccountNumbersFromFormula(formula);
    let result = { status: 0 };
    accountNumbers.forEach((number) => {
        
        try {
            let account = {};
            fetchAccountByNumber(+number, account, accountStructure);

            if (account === undefined) {
                result = { status: 2, error: 'Invalid account id: ' + number };
            }
        } catch (err) {
            result = { status: 2, error: 'Invalid account id: ' + number };
        }
    });
    if (result.status === 2) return result;

     // 3) validate + strip custom functions

      let stripped;
        try {
            const res = validateAndStripCustomFunctions(formula);
            if (!res.ok) return { status: 3, error: res.error };
            stripped = res.stripped;
        } catch (e) {
            return { status: 3, error: e.message || 'Invalid function usage' };
        }

        // 4) replace accounts with 1 and validate math with expr-eval
        //Replace all accounts with the value 1 and evaluate the expression to check if it is valid
        const accountVariableRegex = /\{[A-Za-z0-9_]+\}(?:\[[^\]]*\]|\([-+]?\d+\))?/g;
        let testFormula = stripped.replaceAll(accountVariableRegex, '1');
        
    try {
        Parser.evaluate(testFormula);
    } catch (err) {
        return { status: 3, error: 'Invalid mathematical expression' };
    }
    return { status: 0 };
}

function checkBraces(formula) {
    let open = false;
    for (let c of formula) {
        if (open) {
            if (c === '{') return false;
            else if (c === '}') open = false;
        } else {
            if (c === '{') open = true;
            else if (c === '}') return false;
        }
    }
    return !open;
}

export function recursiveRetrieveValueAccounts(account, valueAccounts) {
    if (account.scenarios) {
        // Check scenarios for value accounts
        account.scenarios.forEach((childAccount) => {
            recursiveRetrieveValueAccounts(childAccount, valueAccounts);
        });
    } else if (account.formula) {
        // Not a value account, do not consider
    } else if (account.relatedAccount) {
        // Not a value account, do not consider
    } else {
        valueAccounts.set(account.account_number, account);
    }
    return valueAccounts;
}

export function findAllAccounts(allAccounts, accountStructure) {
    if (!accountStructure) return;
    
    if (Array.isArray(accountStructure)) {
        for (let i = 0; i < accountStructure.length; i++) {
            const acc = accountStructure[i];
            if (!acc || typeof acc !== "object") continue; 
            
            allAccounts.push(acc);
            if (acc.children !== undefined) {
                findAllAccounts(allAccounts, acc.children);
            }
        }
        return;
    }

  if (typeof accountStructure !== "object") return;

  for (const key in accountStructure) {
    findAllAccounts(allAccounts, accountStructure[key]);
  }
}
    

export function checkAccountNumberExistance(currentFormula, allAccounts) {
    const notFoundAccountNumbers = [];
    let parsedAccountNumbersFromFormula = currentFormula.match(/\{(.*?)\}/g);

    parsedAccountNumbersFromFormula =
        parsedAccountNumbersFromFormula != null
            ? parsedAccountNumbersFromFormula.map((parsedAccountNumber) => {
                  return parsedAccountNumber.replace(/\[.*]?/gi, '}');
              })
            : null;

    if (parsedAccountNumbersFromFormula !== null) {
        parsedAccountNumbersFromFormula.forEach((accountNumber) => {
            const parsedAccountNumber = accountNumber.slice(1, accountNumber.length - 1);
            let isAccountNumberFound = false;

            allAccounts.forEach((account) => {
                if (parsedAccountNumber === account.account_number) {
                    isAccountNumberFound = true;
                }
            });

            if (!isAccountNumberFound) {
                notFoundAccountNumbers.push(parsedAccountNumber);
            }
        });
    }
    return notFoundAccountNumbers;
}

export function checkAccountDependencies(accountNumber, allAccounts) {
    let accountDependencies = [];

    allAccounts.forEach((account) => {
        if (account.group_id < 5) {
            account.formulas.forEach((formula) => {
                let parsedAccountNumbers = formula.formula.match(/(\{[A-Z]*\d*)/g);
                let isAccountNumberFound = false;

                if (parsedAccountNumbers !== null) {
                    parsedAccountNumbers.forEach((parsedAccountNumber) => {
                        if (parsedAccountNumber.slice(1) === accountNumber) {
                            isAccountNumberFound = true;
                        }
                        if (isAccountNumberFound && !accountDependencies.includes(account.account_number)) {
                            accountDependencies.push(account.account_number);
                        }
                    });
                }
            });
        }
    });

    return accountDependencies;
}

